<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">Ponto Manual</div>
      </div>
      <div class="card-body">
        <div class="row mb-1">
          <div class="col-md-12">
            <label><span class="required">*</span> Usuário:</label>
            <v-select
              v-model="manualCheck.user_id"
              :options="users"
              label="name"
              :reduce="user => user.id"
              placeholder="Selecione um usuário"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label><span class="required">*</span> Data</label>
            <input
              type="date"
              class="form-control"
              v-model="manualCheck.date"
            />
          </div>
          <div class="col-md-6">
            <label><span class="required">*</span> Tempo</label>
            <input
              type="text"
              class="form-control"
              v-model="manualCheck.time"
              v-mask="'##:##:##'"
              placeholder="HH:MM:SS"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label><span class="required">*</span> Justificativa</label>
            <textarea
              class="form-control"
              rows="3"
              maxlength="191"
              v-model="manualCheck.justification"
              placeholder="Descreva o motivo do lançamento manual"
            ></textarea>
            <span
              class="badge float-right mt-50"
              style="font-size: 0.9rem"
              :class="justificationLength >= 191 ? 'badge-danger' : justificationLength >= 160 ? 'badge-warning' : 'badge-primary'"
            >
              {{ justificationLength }}/191 caracteres
            </span>
          </div>
        </div>
        <div class="block text-right mt-1">
          <router-link to="/manualChecks" class="btn btn-back">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
          <a class="btn btn-add ml-1" @click="save">
            Salvar
            <i class="fa fa-save"></i>
          </a>
        </div>
        <div class="row">
          <div class="col-md-4">
            <p><span class="required">*</span> Campos Obrigatórios</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [],
      manualCheck: {
        user_id: "",
        time: "",
        date: "",
        justification: "",
      },
    };
  },
  computed: {
    justificationLength: function () {
      return (this.manualCheck.justification || "").length;
    },
  },
  methods: {
    save: function () {
      const self = this;

      if (self.manualCheck.id) return self.edit();

      const api = this.$store.state.api + "checks/manualCheck";

      let fd = self.makeFormData();
      if (!fd) return;

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Ponto manual cadastrado com sucesso`,
            "success"
          );
          this.$router.push("/manualChecks");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    edit: function () {
      const self = this;
      const api =
        self.$store.state.api + "checks/manualCheck/" + self.manualCheck.id;

      let fd = self.makeFormData();
      if (!fd) return;

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Ponto manual editado com sucesso`,
            "success"
          );
          this.$router.push("/manualChecks");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    makeFormData: function () {
      const self = this;

      let fd = new FormData();

      if (!self.manualCheck.time || self.manualCheck.time.length < 8) {
        self.$message("Erro", "Preencha horas válidas", "error");
        return false;
      }

      if (
        !self.manualCheck.justification ||
        self.manualCheck.justification.trim().length < 3
      ) {
        self.$message("Erro", "Preencha a justificativa", "error");
        return false;
      }

      fd.append("user_id", self.manualCheck.user_id);
      fd.append(
        "datetime",
        self.manualCheck.date + " " + self.manualCheck.time
      );
      fd.append("manual", 1);
      fd.append("justification", self.manualCheck.justification);

      if (self.manualCheck.id) {
        fd.append("id", self.manualCheck.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    getUsers: function () {
      const self = this;
      const api = this.$store.state.api + "users?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.users = response.data.data;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getManualCheck: function (id) {
      let self = this;
      let api = self.$store.state.api + "checks/" + id;   

      axios
        .get(api)
        .then((response) => {
          const check = response.data.data[0];          
          // created_at vem serializado em UTC (ISO com "Z"); created_at_f é o horário salvo
          const [day, month, year] = check.created_at_f.substring(0, 10).split("/");
          const date = `${year}-${month}-${day}`;
          const time = check.created_at_f.substring(11, 19);
          self.manualCheck = { ...check, date, time };
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getUsers();

    let id = self.$route.params.id;
    if (id) {
      self.getManualCheck(id);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
